import React from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import { ButtonOBSOLETED } from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import { cleanupToken } from '../../common/auth';

const HomeInternal = props => (
  <LayoutContext.Consumer>
    {() => {
      const { user } = props;

      return (
        <div className='content-width-limiter-narrow'>
          <PageTop
            documentTitle='home'
            documentDescription='home'
          />
          <br />
          Welcome to Wannasport Admin.
          {' '}
          <br />
          {' '}
          <br />
          You are logged in as
          {' '}
          {user.UserName}
          <br />
          {' '}
          <br />

          <ButtonOBSOLETED
            onClick={() => {
              cleanupToken();
              document.location.reload(); // TODO get rid of full document reloading
            }}
            type='button'
            className='button button-primary button-full-width'
            buttonContent='Logout'
            ariaLabel='logout from current user'
          />
        </div>
      );
    }}
  </LayoutContext.Consumer>
);

const Home = withRouter(connect(({ user }) => ({ isLoggedIn: !!user, user }), {})(HomeInternal));
Home.requiresLogin = true;

export default Home;